export default "__VITE_ASSET__BQE4bJAv__"